import { render, staticRenderFns } from "./AvatarSelector.vue?vue&type=template&id=1e4e16f2&scoped=true"
import script from "./AvatarSelector.vue?vue&type=script&lang=js"
export * from "./AvatarSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4e16f2",
  null
  
)

export default component.exports